import history from "@history";
import { coreInstance, konjInstance, mainInstance } from "api";
import axios from "axios";
// import jwtDecode from "jwt-decode";
import { CookieUtils, CookieUtilsInstance, DashboardUtils } from "utils";

class jwtService extends DashboardUtils.EventEmitter {
  constructor(props) {
    super(props);
    this.getExpToken = null;
  }

  init() {
    konjInstance.defaults.headers.common["Accept-Language"] = "fa-ir";

    this.setInterceptors();
    this.handleAuthentication();
  }

  setInterceptors = () => {
    // axios.interceptors.request.use(
    //   (response) => {
    //     console.log('***',response)
    //     return response;
    //   },
    //   (err) => {
    //     console.log('***',err)

    //     return new Promise((resolve, reject) => {
    //       if (
    //         (err.response.status === 401 || err.response.status === 403 )&&
    //         err.config &&
    //         !err.config.__isRetryRequest
    //       ) {
    //         // if you ever get an unauthorized response, logout the user
    //         this.emit("onAutoLogout", "Invalid access_token");
    //         this.setSession(null);
    //       }
    //       throw err;
    //     });
    //   }
    // );

    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (err) => {
        return new Promise((resolve, reject) => {
          if (
            (err.response?.status === 401 || err.response?.status === 403) &&
            err.config &&
            !err.config.__isRetryRequest
          ) {
            // if you ever get an unauthorized response, logout the user
            this.emit("onAutoLogout", "Invalid access_token");
            this.setSession(null);
          }
          throw err;
        });
      }
    );
    coreInstance.interceptors.response.use(
      (response) => {
        return response;
      },
      (err) => {
        return new Promise((resolve, reject) => {
          if (
            (err.response.status === 401 || err.response.status === 403) &&
            err.config &&
            !err.config.__isRetryRequest
          ) {
            // if you ever get an unauthorized response, logout the user
            this.emit("onAutoLogout", "Invalid access_token");
            this.setSession(null);
          }
          throw err;
        });
      }
    );
  };

  // handleAuthentication = () => {
  //   let access_token = this.getAccessToken();

  //   if (!access_token) {
  //     return;
  //   }

  //   if (this.isAuthTokenValid(access_token)) {
  //     this.setSession(access_token);
  //     this.emit("onAutoLogin", true);
  //   } else {
  //     this.setSession(null);
  //     this.emit("onAutoLogout", "access_token expired");
  //   }
  // };
  handleAuthentication = () => {
    let access_token = this.getAccessToken();
    let konjToken = this.getKonjToken();

    // if (!access_token) {
    //   return;
    // }
    if (!access_token) {
      if (history.location.pathname.search("login") !== -1) {
        return;
      }
      this.emit("onAutoLogout", "Invalid access_token");
      this.setSession(null);
    } else {
      if (konjToken) {
        konjInstance.defaults.headers.common[
          "Authorization"
        ] = `Token ${konjToken}`;
      }
      mainInstance.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${access_token}`;
      coreInstance.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${access_token}`;
      axios.defaults.headers.common["Accept-Language"] = "fa-ir";
      // if (history.location.pathname === "/login") {
      //   history.push("/");
      // }
      this.setSession(access_token);
      this.emit("onAutoLogin", true);
    }

    // if (this.isAuthTokenValid(access_token)) {
    //   this.setSession(access_token);
    //   this.emit("onAutoLogin", true);
    // } else {
    //   this.setSession(null);
    //   this.emit("onAutoLogout", "access_token expired");
    // }
  };

  // createUser = (data) => {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/auth/register", data).then((response) => {
  //       if (response.data.user) {
  //         this.setSession(response.data.access_token);
  //         resolve(response.data.user);
  //       } else {
  //         reject(response.data.error);
  //       }
  //     });
  //   });
  // };

  createUser = ({ fullname, mobile, captcha, password, email }) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${process.env.REACT_APP_PUBLIC_APP_URL}/user/register`, {
          fullname,
          mobile,
          captcha,
          password,
          email,
        })
        .then((response) => {
          if (response && response.data.result) {
            // this.setSession(response.data.access_token);
            resolve(response);
          } else {
            reject(response.data.errors);
          }
        });
    });
  };

  resendToken = ({ user_id, type }) => {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${process.env.REACT_APP_PUBLIC_APP_URL}/user/resend-token/${type}`,
          {
            user_id,
          }
        )
        .then((response) => {
          if (response && response.data.result) {
            // this.setSession(response.data.access_token);
            resolve(response);
          } else {
            reject(response.data.errors);
          }
        });
    });
  };

  forgotPass = ({ mobile, captcha }) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${process.env.REACT_APP_PUBLIC_APP_URL}/user/forgot-pass`, {
          mobile,
          captcha,
        })
        .then((response) => {
          if (response && response.data.result) {
            // this.setSession(response.data.access_token);
            resolve(response);
          } else {
            reject(response.data.errors);
          }
        });
    });
  };

  registerConfirm = ({ user_id, code, url }) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${process.env.REACT_APP_PUBLIC_APP_URL}/user/${url}/confirm`, {
          user_id,
          code,
        })
        .then((response) => {
          if (response && response.data.result) {
            if (url === "register") {
              this.getExpToken = response.data.token.expires;
              this.setSession(response.data.token.access_token);
              resolve(response.data.user);
            } else {
              resolve(response.data);
            }
          } else {
            reject(response.data.errors);
          }
        });
    });
  };

  // signInWithEmailAndPassword = (email, password) => {
  //   return new Promise((resolve, reject) => {
  //     axios
  //       .post("http://127.0.0.1:9000/api/v1/users/login", {
  //         email,
  //         password,
  //       })
  //       .then((response) => {
  //         if (response.data.data.user) {
  //           this.setSession(response.data.token);
  //           resolve(response.data.data.user);
  //         } else {
  //           reject(response.data.data.message);
  //         }
  //       });
  //   });
  // };

  signInWithUsername = ({ login, password, captcha }) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${process.env.REACT_APP_PUBLIC_APP_URL}/user/login`, {
          login,
          password,
          captcha,
        })
        .then((response) => {
          if (response && response.data.result) {
            this.getExpToken = response.data.token.expires;
            this.setSession(response.data.token.access_token);
            resolve(response.data.user);
          } else {
            reject(response.data.errors);
          }
        });
    });
  };

  // signInWithToken = () => {
  //   return new Promise((resolve, reject) => {
  //     axios
  //       .post("http://127.0.0.1:9000/api/v1/users/access-token", {
  //         token: this.getAccessToken(),
  //       })
  //       .then((response) => {
  //         if (response.data.data.user) {
  //           this.setSession(response.data.token);
  //           resolve(response.data.data.user);
  //         } else {
  //           reject(response.data.data.message);
  //         }
  //       });
  //   });
  // };

  signInWithToken = () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.REACT_APP_PUBLIC_APP_URL}/auth/check`)
        .then((response) => {
          if (response && response.data.result) {
            this.setSession(response.data.token.access_token);
            resolve(response.data.user);
          } else {
            reject(response.data.message);
          }
        });
    });
  };

  // updateUserData = (user) => {
  //   return axios.post("/api/auth/user/update", {
  //     user: user,
  //   });
  // };

  getCaptch = (page) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.REACT_APP_PUBLIC_APP_URL}/captcha-image/${page}`)
        .then((response) => {
          if (response.data.result) {
            resolve(response.data["captcha-image"]);
          } else {
            reject(response.data.statusText);
          }
        });
    });
  };

  resetPassword = ({ password, password_confirm, resetUrl }) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${process.env.REACT_APP_PUBLIC_APP_URL}/${resetUrl}`, {
          password,
          password_confirm,
        })
        .then((response) => {
          if (response && response.data.result) {
            resolve(response.data);
          } else {
            reject(response.data.errors);
          }
        });
    });
  };

  // setSession = (access_token) => {
  //   if (access_token) {
  //     localStorage.setItem("token", access_token);
  //     axios.defaults.headers.common["Authorization"] = "Bearer " + access_token;
  //   } else {
  //     localStorage.removeItem("token");
  //     delete axios.defaults.headers.common["Authorization"];
  //   }
  // };
  setSession = (access_token) => {
    if (access_token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;
    } else {
      localStorage.clear();
      CookieUtils.removeCookie("token");
      CookieUtils.removeCookie("konjToken");
      delete axios.defaults.headers.common["Authorization"];
    }
  };

  logout = () => {
    this.setSession(null);
  };

  // isAuthTokenValid = (access_token) => {
  //   if (!access_token) {
  //     return false;
  //   }
  //   const decoded = jwtDecode(access_token);
  //   const currentTime = Date.now() / 1000;
  //   if (decoded.exp < currentTime) {
  //     console.warn("access token expired");
  //     return false;
  //   } else {
  //     return true;
  //   }
  // };

  isAuthTokenValid = (access_token) => {
    if (!access_token) {
      return false;
    }
    const currentTime = Date.now();
    if (Date.parse(this.getExpToken) < currentTime) {
      console.warn("access token expired");
      return false;
    } else {
      return true;
    }
  };

  // getAccessToken = () => {
  //   return window.localStorage.getItem("token");
  // };
  getAccessToken = () => {
    return CookieUtilsInstance.getCookie("token");
  };
  getKonjToken = () => {
    return CookieUtilsInstance.getCookie("konjToken");
  };
}

const instance = new jwtService();

export default instance;
